// extracted by mini-css-extract-plugin
module.exports = {"title":"StreamListSkeleton__title__ke1tY"};